export default function Footer () {
    return (
        <footer style={{ marginTop: '60px' }}>
            <p>
                Credits to ABodyPillow, DKrizere & deathbeam for the{' '}
                <a target='_blank' href='https://6jtcys.csb.app/'>
                    original tool
                </a>
            </p>
            <p>
                Credits to{' '}
                <a target='_blank' href='https://www.twitch.tv/snapow'>
                    Snap
                </a>
                ,{' '}
                <a target='_blank' href='https://www.twitch.tv/empyriangaming'>
                    Empy
                </a>{' '}
                and their whole group for the work they put into the original tool and
                the data it uses
            </p>
            <p>
                Credits to{' '}
                <a target='_blank' href='https://github.com/nerdyjoe314'>
                    nerdyjoe314
                </a>{' '}
                for the{' '}
                <a
                    target='_blank'
                    href='https://github.com/nerdyjoe314/divinationscarabs'
                >
                    original algorithm
                </a>{' '}
                used to calculate the best maps to use
            </p>
            <p>
                Card prices and weightings taken from{' '}
                <a target='_blank' href='https://poe.ninja/'>
                    Poe Ninja
                </a>
            </p>
            <p>
                Thanks to{' '}
                <a target='_blank' href='https://www.twitch.tv/dapanotv'>
                    DapanoTV
                </a>{' '}
                for triggering my autism and making me do this :)
            </p>
            <p>
                <a target='_blank' href='https://github.com/Stiwoz/poe.stiwoz.cloud'>
                    Source code
                </a>
            </p>
        </footer>
    );
}